<template>

  <div
      class="flex flex-col mx-auto col-span-3 md:col-span-1 bg-white shadow rounded-lg mb-6 md:opacity-80 border-2 border-indigo-600">
    <div class="flex-1">

      <div class="p-8 text-3xl font-bold border-b-4 h-auto relative border-indigo-500">
        <div class="absolute my-auto left-0 right-0 top-0 transform -translate-y-1/2">
          <span class="rounded-full bg-indigo-600 py-1.5 px-4 text-sm font-semibold text-white">Most popular</span>
        </div>
        <img class="inline-block w-1/2 mb-4"
             src="/images/pro.png"/>
        <br>
        Premium
      </div>
      <small>Use left toggle switch button to select features</small>
      <hr class="h-1  my-0 py-0">
      <ul class="text-sm lg:text-base grid grid-cols-6">
        <li v-if="selectedPlan?.name" class="border-b p-4 col-span-6">
          <strong>Plan - {{ selectedPlan?.name }}</strong>
        </li>
        <li v-else class="border-b p-4 col-span-6">
          <strong>Please select a product</strong>
        </li>
        <div class="col-span-1 align-middle p-2 border-b">
          <a-switch v-model:checked="featureSettings.retro.enabled" @click="toggleProduct('retro')" class="bg-indigo-600"/>
<!--          <Switch @click="toggleProduct('retro')" v-model="featureSettings.retro.enabled"-->
<!--                  :class="[featureSettings.retro.enabled ? 'bg-indigo-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2']">-->
<!--            <span aria-hidden="true"-->
<!--                  :class="[featureSettings.retro.enabled ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']"/>-->
<!--          </Switch>-->
        </div>
        <li id="retro-feature" class="border-b p-4 col-span-4">

          <div v-if="featureSettings.retro.enabled">Retro App - <strong>Unlimited</strong></div>
          <div v-else>Public Retro Boards - <strong>5</strong></div>
        </li>

        <div v-if="featureSettings.retro.enabled" id="retro-pr88ice"
             class="col-span-1 border-b p-4 text-blue-600 font-bold">${{ featureSettings.retro.price }}
        </div>
        <div v-else id="retro-pri19ce" class="col-span-1 border-b p-4 font-bold">FREE</div>

        <div class="col-span-1 align-middle p-2 border-b">
          <a-switch v-model:checked="featureSettings.poker.enabled" @click="toggleProduct('poker')"/>
<!--          <Switch @click="toggleProduct('poker')" v-model="featureSettings.poker.enabled"-->
<!--                  :class="[featureSettings.poker.enabled ? 'bg-indigo-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2']">-->
<!--            <span aria-hidden="true"-->
<!--                  :class="[featureSettings.poker.enabled ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']"/>-->
<!--          </Switch>-->
        </div>
        <li id="poker-feature" class="border-b p-4 col-span-4">
          <div v-if="featureSettings.poker.enabled">Poker App - <strong>Unlimited</strong></div>
          <div v-else>Public Poker Sessions - <strong>100</strong></div>
        </li>
        <div v-if="featureSettings.poker.enabled" id="poker-pri6ce"
             class="col-span-1 border-b p-4 text-blue-600 font-bold">${{ featureSettings.poker.price }}
        </div>
        <div v-else id="poker-pri7ce" class="col-span-1 border-b p-4 font-bold">FREE</div>

        <div class="col-span-1 align-middle p-2 border-b">
          <a-switch v-model:checked="featureSettings.report.enabled" @click="toggleProduct('report')"/>
<!--          <Switch @click="toggleProduct('report')" v-model="featureSettings.report.enabled"-->
<!--                  :class="[featureSettings.report.enabled ? 'bg-indigo-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2']">-->
<!--            <span aria-hidden="true"-->
<!--                  :class="[featureSettings.report.enabled ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']"/>-->
<!--          </Switch>-->
        </div>
        <li id="report-feature" class="border-b p-4 col-span-4">
          <div v-if="featureSettings.report.enabled">Slack Async Report - <strong>20 Report Templates*</strong></div>
          <div v-else>Slack Async Report - <strong>1 Report Template*</strong></div>
        </li>
        <div v-if="featureSettings.report.enabled" id="report-price1"
             class="col-span-1 border-b p-4 text-blue-600 font-bold">${{ featureSettings.report.price }}
        </div>
        <div v-else id="report-pr3ice" class="col-span-1 border-b p-4 font-bold">FREE</div>
      </ul>
    </div>
    <div class="flex-1 p-8">
      <p class="text-6xl font-bold mb-6">
        <span class="text-2xl text-blue-600">$</span>
        <span id="total-price"
              class="text-blue-600">{{ selectedPlan?.options?.price ?? 0 }}
      </span>
        <span
            v-if="discounted" id="original-price"
            class="line-through text-base text-gray-600">{{ totalPriceNoDiscount }}</span>
        <span class="block text-base text-sm"> USD / user / month </span>
      </p>
      <p v-if="selectedPlan" class="mb-6">
        <a v-if="plan.unit_price === 0" :href="'/billing?subscribe=' + selectedPlan?.monthly_id"
           class="focus:outline-none shadow-lg text-md md:text-lg rounded-md bg-indigo-600 hover:bg-indigo-700 text-white lg:text-lg mt-5 py-3 px-10  font-bold mr-2 font-bold rounded-full">
          Checkout
        </a>
        <a v-else href="#" @click="changePlan"
           class="focus:outline-none shadow-lg text-md md:text-lg rounded-md bg-indigo-600 hover:bg-indigo-700 text-white lg:text-lg mt-5 py-3 px-10  font-bold mr-2 font-bold rounded-full">
          Change Plan
        </a>
        <br>
      </p>
    </div>
  </div>
</template>

<script>


import {onMounted, ref, reactive, defineEmits} from 'vue';
import {message} from "ant-design-vue";
import {Switch} from '@headlessui/vue'

export default {

  props: {
    planSettings: Array,
    plan: Object,
    userId: Number,
  },
  data() {
    return {}
  },
  beforeMount() {

  },
  created() {
  },
  setup(props, {emit}) {
    const {planSettings} = props;
    const retroPrice = planSettings.find(e => e.name === 'Retrospective')?.options?.price;
    const pokerPrice = planSettings.find(e => e.name === 'Planning Poker')?.options?.price;
    const reportPrice = planSettings.find(e => e.name === 'Async Report')?.options?.price;
    const pokerChecked = ref(true);

    const totalPriceNoDiscount = retroPrice + pokerPrice + reportPrice;

    const discounted = ref(true);

    const featureSettings = reactive({
      retro: {
        enabled: true,
        price: retroPrice,
        featureKey: 'retro_boards',
        planName: 'Retrospective'
      },
      poker: {
        enabled: true,
        price: pokerPrice,
        featureKey: 'poker_sessions',
        planName: 'Planning Poker'
      },
      report: {
        enabled: true,
        price: reportPrice,
        featureKey: 'slack_async_report',
        planName: 'Async Report'
      }
    });

    const loading = ref(false);

    const selectedPlan = ref(planSettings.find(e => e.name === 'Bundle'));

    function toggleProduct(product) {
      //featureSettings[product].enabled = !featureSettings[product].enabled;
      const selectedProducts = [];
      for (const feature in featureSettings) {
        if (featureSettings[feature].enabled) {
          selectedProducts.push(featureSettings[feature]);
        }
      }

      if (selectedProducts.length === 3) {
        selectedPlan.value = planSettings.find(e => e.name === 'Bundle');
        discounted.value = true;
        return
      }
      discounted.value = false;

      if (selectedProducts.length === 2) {
        // console.log(planSettings);
        // console.log(selectedProducts);
        selectedPlan.value = planSettings.find(plan => plan.options.feature_keys.length === 2 && selectedProducts.every(product => plan.options?.feature_keys.includes(product.featureKey)));
      }
      if (selectedProducts.length === 1) {
        selectedPlan.value = planSettings.find(e => e.name === selectedProducts[0].planName);
        // console.log(selectedProducts)
        // console.log(planSettings.find(e => e.name === selectedProducts[0].planName));
      }
      if (selectedProducts.length === 0) {
        selectedPlan.value = undefined;
        return;
      }
    }

    function changePlan() {
      if (selectedPlan.value.name === props.plan.name) {
        message.error("The plan you selected is the same as the one you already subscribed, please select different products to change your plan.", 10)
        return;
      }
      emit('setLoading', true);
      axios.put('/spark/subscription', {
        billableId: props.userId,
        billableType: 'user',
        plan: selectedPlan.value.monthly_id
      }).then(response => {
        emit('fetchPlan');
        message.success("Your plan has been updated successfully!", 3);
      }).catch((e) => {
        console.log(e);
        emit('setLoading', false);
        message.error("Encountered some issue...Please try again. If the issue persists please contact us at support@agilesuite.io", 3);
      });
    }


    return {
      loading,
      selectedPlan,
      toggleProduct,
      totalPriceNoDiscount,
      discounted,
      featureSettings,
      changePlan,
      pokerChecked
    }
  },

  methods: {
  },
  components: {},
};
</script>